// extracted by mini-css-extract-plugin
export default {"thumbnail":"L9SGP2","title":"paQmjt","date":"wjoFiP"};